import React, {useEffect, useRef, useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import {useNavigate, useParams} from "react-router-dom";
import apiClient from "../../utils/api";
import {useForm} from "react-hook-form";
import ValidationError from "../../components/Form/ValidationError";
import {Spinner} from "react-bootstrap";

function WebUsersEdit() {
    const [countries, setCountries] = useState([]);
    const {id} = useParams();
    const [imageUrl, setImageUrl] = useState("");
    const [verrors, setErrors] = useState({});
    const navigate = useNavigate()
    const [selectedFile, setSelectedFile] = useState(null);
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        is_active: "1",
        dob: '',
        referral_source: '',
        nationality: ''
    });

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors}
    } = useForm();

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleInputChange = (e) => {
        const {name, value, checked} = e.target;
        if (name === "permissions") {
            setFormData((prevState) => {
                const updatedPermissions = checked ? [...prevState.permissions, value] : prevState.permissions.filter((key) => key !== value);

                return {...prevState, [name]: updatedPermissions};
            });
        } else {
            setFormData({...formData, [name]: value});
        }
    };

    const fetchCountries = async () => {
        try {
            const response = await apiClient.get('countries');
            setCountries(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };    useEffect(() => {
        fetchCountries();
        
        // Fetch permissions from API
        const fetchPermissions = async () => {
            try {
                const token = localStorage.getItem('auth_token');
                const response = await apiClient.get('/permissions', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                if (response.data && response.data.status === 'success') {
                    setPermissions(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching permissions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPermissions();
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiClient.get(`admin/webusers/${id}/edit`);
                const data = response.data.data;
                setImageUrl(data.image);

                setFormData((prevFormData) => ({
                    ...prevFormData,
                    name: data.name,
                    email: data.email,
                    dob: data.dob,
                    is_active: data.is_active ? "1" : "0",
                    nationality: data.nationality,
                    referral_source: data.referral_source
                }));
                setValue('name', data.name);
                setValue('email', data.email);
                setValue('dob', data.dob);
                setValue('nationality', data.nationality);
                setValue('referral_source', data.referral_source);
                setValue('is_active', data.is_active ? "1" : "0");
            } catch (error) {
                console.error('Error fetching API key data:', error);
            }
        };

        if (id) fetchData();
    }, [id, setValue]);




    const onSubmit = async (e) => {
       // e.preventDefault(); // Prevent default form submission behavior

        //setLoading(true);
        const data = new FormData();
        data.append('name', formData.name);
        data.append('email', formData.email);
        data.append('dob', formData.dob);
        data.append('nationality', formData.nationality);
        data.append('is_active', formData.is_active);
        data.append('referral_source', formData.referral_source);
        data.append('_method', 'PUT');

        if (selectedFile) {
            data.append('image', selectedFile);
        }

        try {
            const response = await apiClient.post(`admin/webusers/${id}`, data);
            //toast.success(response.data.message);
            navigate(process.env.PUBLIC_URL + '/web-users-list');
        } catch (error) {
            console.error('Error submitting form:', error);
            //toast.error('Error adding product');
        } finally {
            //setLoading(false);
        }
    };


    return (<div className="container-xxl">
            <form onSubmit={handleSubmit(onSubmit)}>
                <PageHeader1 pagetitle='Admin User Edit' button={true}/>
                <div className="row g-3">
                    <div className="col-xl-3 col-lg-3">
                        <div className="sticky-lg-top">
                            <div className="card mb-3">
                                <ActiveStatus
                                    onStatusChange={handleInputChange}
                                    checked={formData.is_active}
                                    name="is_active"
                                />
                            </div>

                            <div className="card mb-3">
                                <div className="col-md-12">
                                    <div
                                        className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                        <label className="form-label">Image Upload</label>
                                        <small className="d-block text-muted mb-2"> 2M max.</small>
                                    </div>
                                    <div className="card-body">
                                        <div id='create-token' className='dropzone'>
                                            {selectedFile ? (
                                                <img src={URL.createObjectURL(selectedFile)} alt="Selected"/>
                                            ) : imageUrl ? (
                                                <img src={imageUrl} alt="Existing"/>
                                            ) : (
                                                <div className='dz-message'>
                                                    <i className="fa fa-picture-o" aria-hidden="true"></i>
                                                </div>
                                            )}
                                            <input
                                                id='filesize'
                                                onChange={handleFileChange}
                                                name="file"
                                                type="file"
                                                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .mp4, .webm, .mp3, awv, .ogg, .glb"></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-9 col-lg-9">
                        <div className="card mb-3">
                            <div
                                className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                <h6 className="mb-0 fw-bold ">Basic information</h6>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row g-3 align-items-center">
                                        <div className="col-md-6">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formData.name}
                                                {...register('name', {
                                                    required: 'Name is required',
                                                    onChange: (e) => handleInputChange(e)
                                                })}
                                            />
                                            <ValidationError error={errors.name}/>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Email</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.email}
                                                name="email"
                                                {...register('email', {
                                                    required: 'Email is required',
                                                    onChange: (e) => handleInputChange(e)
                                                })}
                                            />
                                        </div>
                                        <ValidationError error={errors.email}/>

                                        <div className="col-md-6">
                                            <label className="form-label">Nationality</label>
                                            <select
                                                value={formData.nationality}
                                                onChange={handleInputChange}
                                                name="nationality"
                                                className="form-control"
                                            >
                                                <option value="">Select Nationality</option>
                                                {countries.map((country) => (
                                                    <option
                                                        value={country.countryName}>{country.countryName}</option>))}
                                            </select>
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Date Of Birth</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={formData.dob}
                                                name="dob"
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Referral Source</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.referral_source}
                                                name="referral_source"
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>

    )
}

export default WebUsersEdit;